import './assets/main.css'

import { initOverlayScrollLock } from '@/utils/overlayScrollLock'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import ToastComponent from './components/ToastComponent.vue'

const app = createApp(App)
// 挂载到全局，组件内直接用 $axios
app.config.globalProperties.$axios = axios
app.provide('axios',axios)

app.use(createPinia())
app.use(router)

app.component('ToastComponent', ToastComponent)

app.mount('#app')

initOverlayScrollLock()
